module.exports = __webpack_public_path__ + "img/zhaoPing.3e89c664.png";